import React from 'react';
import { Box, Text, IconButton } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

export default function SelectedChips({
  items = [],
  getKey,
  getLabel,
  onRemove,
  chipBg,
  chipText,
  mb = 3,
}) {
  if (!items.length) return null;

  return (
    <Box display="flex" flexWrap="wrap" gap="8px" mb={mb}>
      {items.map((item) => {
        const key = getKey(item);
        const label = getLabel(item);

        return (
          <Box
            key={key}
            bg={chipBg}
            color={chipText}
            px={3}
            py={1}
            borderRadius="full"
            display="flex"
            alignItems="center"
            gap="6px"
          >
            <Text fontSize="sm" fontWeight="500">
              {label}
            </Text>

            <IconButton
              icon={<CloseIcon boxSize={2.5} />}
              size="xs"
              variant="ghost"
              aria-label="Remove"
              onClick={() => onRemove(item)}
              _hover={{ bg: 'blackAlpha.200' }}
            />
          </Box>
        );
      })}
    </Box>
  );
}
